"use client";

// The per-contact grant list shown on an EMPLOYEE's Access tab.
// Split out of AdminUserDetailTabComponents.tsx (module-size).

import { Badge, EmptyState } from "@wtc/ui";
import { Users as UsersIcon, ExternalLink } from "lucide-react";
import type { AccessibleContact } from "@/components/admin/users/UserDetailModal/use-user-access-grants";

export function AccessGrantList({
  title,
  emptyTitle,
  emptyDescription,
  grants,
  showAccessLevel = false,
  onOpenContact,
}: {
  title: string;
  emptyTitle: string;
  emptyDescription: string;
  grants: AccessibleContact[];
  showAccessLevel?: boolean;
  onOpenContact: (contactId: string) => void;
}) {
  if (grants.length === 0) {
    return <EmptyState icon={UsersIcon} title={emptyTitle} description={emptyDescription} />;
  }

  return (
    <div className="flex flex-col gap-2">
      <span className="text-xs font-medium text-muted-foreground">
        {title} ({grants.length})
      </span>
      <ul className="flex flex-col gap-1">
        {grants.map((grant) => (
          <li key={grant.grantId}>
            <button
              type="button"
              onClick={() => onOpenContact(grant.contactId)}
              className="w-full flex items-center justify-between gap-2 rounded-md border px-3 py-2 text-left hover:bg-accent transition-colors"
            >
              <span className="flex flex-col min-w-0">
                <span className="text-sm font-medium truncate inline-flex items-center gap-1">
                  {grant.contactName || grant.contactEmail || "Unnamed contact"}
                  <ExternalLink className="h-3 w-3 text-muted-foreground shrink-0" />
                </span>
                {(grant.companyName || grant.contactEmail) && (
                  <span className="text-xs text-muted-foreground truncate">
                    {grant.companyName || grant.contactEmail}
                  </span>
                )}
              </span>
              {showAccessLevel && grant.accessLevel && (
                <Badge variant="secondary" className="shrink-0 capitalize">
                  {grant.accessLevel.replace(/_/g, " ")}
                </Badge>
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
